import { render, staticRenderFns } from "./attribute-value-association.vue?vue&type=template&id=e423ba4a&scoped=true&"
import script from "./attribute-value-association.vue?vue&type=script&lang=js&"
export * from "./attribute-value-association.vue?vue&type=script&lang=js&"
import style0 from "./attribute-value-association.vue?vue&type=style&index=0&id=e423ba4a&prod&lang=scss&scoped=true&"
import style1 from "./attribute-value-association.vue?vue&type=style&index=1&id=e423ba4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e423ba4a",
  null
  
)

export default component.exports